<template lang="pug">
#ExportButton(v-if="isDesktop")
    button(@click="exportClick") Export
</template>

<script>
export default {
    name: 'ExportButton',
    data: () => ({}),
    created() {
        window.ExportButton = this;
    },
    computed: {
        isDesktop() {
            const ua = navigator.userAgent;
            return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
                ua
            );
        },
    },
    methods: {
        exportClick() {
            const bounds = window.map.getBounds();
            const mapel = document.getElementById('map');
            mapel.style.width = '800px'; //mapel.offsetWidth + 'px';
            mapel.style.height = '600px'; //mapel.offsetHeight + 'px';

            window.map.resize();
            window.map.fitBounds(bounds);

            window.setTimeout(() => {
                window.print();
                // $('body').toggleClass('printing', false);
                mapel.style.width = '';
                mapel.style.height = '';
                window.map.resize();
                window.map.fitBounds(bounds);
            }, 500);
            window.track('ExportButton', 'click');
        },
    },
};
</script>

<style scoped>
button {
    cursor: pointer;
    width: 100%;
    margin: 1em 0 0 0;
    padding: 10px 15px;
    border-radius: 3px;
    border: 1px solid grey;
}

@media print {
    #ExportButton {
        display: none;
    }
}
</style>
